import { IIndustryResponse } from '@kcftech/prometheustypescriptapiclient';
import { DataSourceTable } from 'components/data_source_table/DataSourceTable';
import { TableColumn } from 'components/data_table/types';
import { ActionMenuTableCell } from 'components/menu/ActionMenuTableCell';
import { IndustriesPagedDataSource } from 'custom_hooks/data_hooks/data_source/industriesDataSource';
import { DeleteIndustryModal } from 'pages/Settings/Industries/DeleteIndustryModal';
import { IndustryNameCell } from 'pages/Settings/Industries/IndustryNameCell';
import { useMemo } from 'react';
import { getId } from 'utils/data';

export type IndustriesTableProps = Readonly<{
    dataSource: IndustriesPagedDataSource;
}>;

export type IndustriesTableCellProps = Readonly<{
    rowData: IIndustryResponse;
    onChange: () => void;
}>;

export function IndustriesTable({ dataSource }: IndustriesTableProps) {
    const { reloadPage } = dataSource;
    const columns = useMemo<TableColumn<IIndustryResponse>[]>(
        () => [
            {
                id: 'Industry',
                header: () => 'Industry',
                value: ({ rowData }) => (
                    <IndustryNameCell rowData={rowData} onChange={reloadPage} />
                ),
                primary: true,
                sortOn: ['Name'],
            },
            {
                id: 'actions',
                header: () => 'Actions',
                value: ({ rowData }) => (
                    <ActionMenuTableCell>
                        <DeleteIndustryModal industry={rowData} onDelete={reloadPage} />
                    </ActionMenuTableCell>
                ),
            },
        ],
        [reloadPage]
    );

    return (
        <DataSourceTable
            dataSource={dataSource}
            noResultMessage="No industries found"
            columns={columns}
            rowKey={getId}
        />
    );
}
